export enum RefundDestinationType {
  Psp = 0,
  Cash = 1,
  GiftCardNew = 2,
  GiftCardReload = 3,
  RegistrationOnly = 4,
}
